/** `/c/$companyId/settings/cost-centres` — cost centres; anyone with access reads them. */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { CostCentresScreen } from "../ledger/CostCentresScreen";

export const Route = createFileRoute("/_auth/c/$companyId/settings/cost-centres")({
  component: CostCentresRoute,
});

function CostCentresRoute(): JSX.Element {
  const { companyId } = Route.useParams();
  return <CostCentresScreen companyId={companyId} />;
}
